//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "configuration/properties",
], function (Backbone, $, _, Messenger, Properties) {
  "use strict";

  const SiteMapsModel = {};

  SiteMapsModel.siteMap = Backbone.Model.extend({
    defaults: function () {
      return {
        name: "",
        cssFileName: "",
        cssUploadId: "",
        kbId: Messenger.reqres.request("active:kb"),
        languageId: Messenger.reqres.request("default:response:language"),
        templateFileName: "",
        templateUploadId: "",
        touchPointIds: [Messenger.reqres.request("default:touchpoint")],
        privilegedAreaRoleIds: [],
      };
    },
    uploads: function () {
      this.uploadsCol = this.getSubModel(this.uploadsCol, SiteMapsModel.siteMapUploads, "/uploads");
      this.uploadsCol.siteMap = this;
      return this.uploadsCol;
    },
    saveChildren: function (options) {
      this.saveSubModels(options);
    },
    _validateDuplicateSiteMapName: function (value) {
      if (this.collection) {
        for (let i = 0; i < this.collection.length; i++) {
          // validate against free text attribute names
          const otherSiteMap = this.collection.at(i);
          if (this !== otherSiteMap) {
            if (value.toLocaleUpperCase() == otherSiteMap.get("name").toLocaleUpperCase()) {
              return $.t("admin.siteMaps.duplicateNameError");
            }
          }
        }
      }
    },
    validateAttribute: function (attribute, value) {
      switch (attribute) {
        case "name":
          return (
            this.validateRequiredValue(value, { maxLength: 255 }) ||
            this.validateSafeCharacters(value) ||
            this._validateDuplicateSiteMapName(value)
          );
        case "templateUploadId":
          return this.validateRequiredValue(value);
        case "touchPointIds":
          if (!value || !value.length) {
            return $.t("commonMessages.emptyMessage");
          }
          break;
      }
    },
  });

  SiteMapsModel.siteMaps = Backbone.Collection.extend({
    model: SiteMapsModel.siteMap,
    initializeCustom: function (options) {
      this.kbId = options.kbId;
      if (this.kbId) {
        this.fetch();
      }
    },
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
    addItem: function () {
      const newSiteMap = new SiteMapsModel.siteMap();
      this.add(newSiteMap);
      return newSiteMap;
    },
    url: function () {
      return Properties.adminRootURL + "/kbs/" + this.kbId + "/site_maps";
    },
  });

  SiteMapsModel.siteMapUpload = Backbone.Model.extend({
    defaults: function () {
      return {
        description: "",
        kbId: Messenger.reqres.request("active:kb"),
        siteMapId: 0,
        uploadId: "",
      };
    },
  });

  SiteMapsModel.siteMapUploads = Backbone.Collection.extend({
    model: SiteMapsModel.siteMapUpload,
    addItem: function (data) {
      data = data || {};
      if (this.siteMap && !this.siteMap.isNew()) {
        data.siteMapId = this.siteMap.get("id");
      }
      const upload = new SiteMapsModel.siteMapUpload(data);
      this.add(upload);
      return upload;
    },
  });

  return SiteMapsModel;
});
